export default __webpack_public_path__ + "images/650d295fee677501ffd832c7832c750e-balance-using-your-senses.svg";